export default __webpack_public_path__ + "static/soehne-web-kraftig-c6506a207af6ae2093e96c5167fbed13.woff";